/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type QuickViewCategoryParagraph_item = {
    readonly quickViewDisplay: {
        readonly paragraphAttributeNames: {
            readonly period: string | null;
            readonly origin: string | null;
            readonly style: string | null;
            readonly periodPrefix: string | null;
        } | null;
    } | null;
    readonly " $refType": "QuickViewCategoryParagraph_item";
};
export type QuickViewCategoryParagraph_item$data = QuickViewCategoryParagraph_item;
export type QuickViewCategoryParagraph_item$key = {
    readonly " $data"?: QuickViewCategoryParagraph_item$data;
    readonly " $fragmentRefs": FragmentRefs<"QuickViewCategoryParagraph_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "QuickViewCategoryParagraph_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "quickViewDisplay",
      "storageKey": null,
      "args": null,
      "concreteType": "QuickViewDisplayType",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "paragraphAttributeNames",
          "storageKey": null,
          "args": null,
          "concreteType": "QuickViewCategorySegments",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "period",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "origin",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "style",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "periodPrefix",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '1200a2e512ce9218f0d0b8c85128d593';
export default node;
